export const LOADING = 'LOADING'
export const STOP_LOADING = 'STOP_LOADING'

export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_LOGIN_SUCCESSFUL = 'AUTH_LOGIN_SUCCESSFUL'
export const AUTH_RELOAD_VERIFICATION = 'AUTH_RELOAD_VERIFICATION'
export const AUTH_PROFILE_PIC = 'AUTH_PROFILE_PIC'

export const PROFILE_FETCH = 'PROFILE_FETCH'

export const MODAL_SHOW = 'MODAL_SHOW'
export const MODAL_HIDE = 'MODAL_HIDE'